
import React from 'react';
import { BrowserRouter, Route, Link } from 'react-router-dom'
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';

import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

import { Hub, Logger } from 'aws-amplify';
import { withOAuth } from 'aws-amplify-react';

import { mailFolderListItems, otherMailFolderListItems } from './tileData';

import Datasets from './datasets.jsx';
import Dataset from './dataset.jsx';

import Labeler from './labeler/labeler.jsx';

import Videos from './videos.jsx';
import Video from './video.jsx';

import Images from './images.jsx';
import Image from './image.jsx';

const drawerWidth = 185;

const authWatcher = new Logger('Authwatcher');

const styles = theme => ({
  root: {
    flexGrow: 1,
    height: '100%',
    zIndex: 1,
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  flex: {
      textAlign: 'left',
      flex: 1,
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 36,
  },
  hide: {
    display: 'none',
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing.unit * 7,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing.unit * 9,
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing.unit * 3,
  },
});

const Home = () => {
    return (
        <div>
            <h2>Home</h2>
            <p>Select an item from the left to continue.</p>
        </div>
    );
};

const Entities = () => {
    return (
        <div>
            <h2>Entities</h2>
        </div>
    );
}

const Classifiers = () => {
    return (
        <div>
            <h2>Classifiers</h2>
        </div>
    );
}

const NewJob = () => {
    return (
        <div>
            <h2>New Job</h2>
        </div>
    );
}



class MiniDrawer extends React.Component {
  authWatcher = new Logger('authWatcher');

  state = {
    open: true,
    loggedIn: false,
    loggedInUser: null,
  };

  componentWillMount = () => {
      this.authWatcher.onHubCapsule = (capsule) => {
          switch (capsule.payload.event) {
              case 'signIn':
                this.authWatcher.error(`User ${capsule.payload.data.username} signed in poop`);
                this.setState({ loggedIn: true, loggedInUser: capsule.payload.data.username });
                break;
              case 'signOut':
                this.authWatcher.error('User signed out poop');
                this.setState({ loggedIn: false, loggedInUser: null });
                break;
          }
      };

      Hub.listen('auth', this.authWatcher);
  };

  handleDrawerOpen = () => {
    this.setState({ open: true });
  };

  handleDrawerClose = () => {
    this.setState({ open: false });
  };

  render() {
    const { classes, theme } = this.props;
    const { loggedIn, loggedInUser } = this.state;

    return (
      <div className={classes.root}>
        <AppBar
          position="absolute"
          className={classNames(classes.appBar, this.state.open && classes.appBarShift)}
        >
          <Toolbar disableGutters={!this.state.open}>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={this.handleDrawerOpen}
              className={classNames(classes.menuButton, this.state.open && classes.hide)}
            >
              <MenuIcon />
            </IconButton>
            <Typography className={classes.flex} variant="title" color="inherit" noWrap>
              deeplearn.lol
            </Typography>
            {!loggedIn && (
                <Button color="inherit" onClick={this.props.OAuthSignIn}>Login</Button>
            )}
          </Toolbar>
        </AppBar>
        <Drawer
          variant="permanent"
          classes={{
            paper: classNames(classes.drawerPaper, !this.state.open && classes.drawerPaperClose),
          }}
          open={this.state.open}
        >
          <div className={classes.toolbar}>
            <IconButton onClick={this.handleDrawerClose}>
              {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
            </IconButton>
          </div>
          <Divider />
          <List>{mailFolderListItems}</List>
          <Divider />
          <List>{otherMailFolderListItems}</List>
        </Drawer>
        <main className={classes.content}>
            <div className={classes.toolbar} />
            <Route exact path="/" component={Home} />
            <Route path="/videos" component={Videos} />
            <Route path="/video/:id" component={Video} />
            <Route path="/images" component={Images} />
            <Route path="/image/:id" component={Image} />
            <Route path="/labeler/:dataset_id/:dataset_item_id" component={Labeler} />
            <Route path="/dataset/:id" component={Dataset} />
            <Route path="/datasets" component={Datasets} />
            <Route path="/entities" component={Entities} />
            <Route path="/classifiers" component={Classifiers} />
        </main>
      </div>
    );
  }
}

MiniDrawer.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withOAuth(withStyles(styles, { withTheme: true })(MiniDrawer));



// WEBPACK FOOTER //
// ./src/components/drawer.jsx